/**
 * @generated SignedSource<<3679c3f68c33a119a1cb5f4f1941aa2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type resultListQuery$data = {
  readonly articleSearch: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly content: {
          readonly entityId: string;
        } | null | undefined;
      };
      readonly " $fragmentSpreads": FragmentRefs<"resultListContainerArticleSearchEdge">;
    }>;
    readonly resultId: string | null | undefined;
    readonly totalCount: number;
  } | null | undefined;
  readonly topicSearch: {
    readonly edges: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"topicsCardTopicSearchEdge">;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "resultListQuery";
};
export type resultListQuery$key = {
  readonly " $data"?: resultListQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"resultListQuery">;
};

import searchArticleResultPaginationQuery_graphql from './searchArticleResultPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "articleSearch"
],
v1 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "query"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "articleTypeIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentTypes"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDate"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "mode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "paywallTypeIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "query"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sectionIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "streamId"
    },
    {
      "defaultValue": 0,
      "kind": "LocalArgument",
      "name": "variant"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": searchArticleResultPaginationQuery_graphql
    }
  },
  "name": "resultListQuery",
  "selections": [
    {
      "alias": "articleSearch",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "articleTypes",
              "variableName": "articleTypeIds"
            },
            {
              "kind": "Variable",
              "name": "contentTypes",
              "variableName": "contentTypes"
            },
            {
              "kind": "Variable",
              "name": "endDate",
              "variableName": "endDate"
            },
            {
              "kind": "Variable",
              "name": "paywallTypeIds",
              "variableName": "paywallTypeIds"
            },
            (v1/*: any*/),
            {
              "kind": "Variable",
              "name": "sectionIds",
              "variableName": "sectionIds"
            },
            {
              "fields": [
                {
                  "kind": "Literal",
                  "name": "enabled",
                  "value": true
                },
                {
                  "kind": "Variable",
                  "name": "mode",
                  "variableName": "mode"
                },
                {
                  "kind": "Variable",
                  "name": "streamId",
                  "variableName": "streamId"
                }
              ],
              "kind": "ObjectValue",
              "name": "sse"
            },
            {
              "kind": "Variable",
              "name": "startDate",
              "variableName": "startDate"
            },
            {
              "kind": "Variable",
              "name": "variant",
              "variableName": "variant"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        }
      ],
      "concreteType": "ArticleSearchConnection",
      "kind": "LinkedField",
      "name": "__articleSearchResultListQuery__articleSearch_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resultId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleSearchResultItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "resultListContainerArticleSearchEdge"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v1/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        }
      ],
      "concreteType": "TopicSearchConnection",
      "kind": "LinkedField",
      "name": "topicSearch",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TopicSearchEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "topicsCardTopicSearchEdge"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "194d92544d4ae3e1ccdc644c25cc8e59";

export default node;
